// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__qWDHA","tabs":"style_tabs__Vf2py","tab":"style_tab__ye6_v","tabHref":"style_tabHref__bOvxj","iconBackground":"style_iconBackground__BpNBL"};